const translations = {
  "en": {
    "Earnings Calendar": "Earnings Calendar",
    "No Earning Reports Today": "No Earning Reports Today",
    "Select another date to view reports.": "Select another date to view reports."
  },
  "zh-tw": {
    "Earnings Calendar": "財報日曆",
    "No Earning Reports Today": "今天沒有財報",
    "Select another date to view reports.": "選擇其他日期以查看報告。"
  }
};

export default translations;
